import axios, {
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';
import { TOO_MANY_SEARCH_RESULTS } from '../defineTdm';
import { addAlert, goTo } from '../configTdm';
import { Store } from 'redux';
import { spinnerHide, spinnerShow } from './spinner';

let numOfProcesses = 0;

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  showSpinner?: boolean;
}

const hideSpinnerIfApplicable = (response: AxiosResponse, dispatch: any) => {
  if ((response.config as CustomAxiosRequestConfig).showSpinner) {
    numOfProcesses--;
    if (numOfProcesses <= 0) {
      spinnerHide();
      numOfProcesses = 0;
    }
  }
};

const setupInterceptors = (store: Store) => {
  axios.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const customConfig = config as CustomAxiosRequestConfig;
      if (customConfig.showSpinner) {
        numOfProcesses++;
        spinnerHide();
        spinnerShow();
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    },
  );

  axios.interceptors.response.use(
    response => {
      hideSpinnerIfApplicable(response, store.dispatch);
      return response;
    },
    error => {
      const { response } = error;
      hideSpinnerIfApplicable(response, store.dispatch);

      if (response.status) {
        if (response.status === 401) {
          if (window.opener) {
            window.close();
          } else {
            goTo('/home');
          }
        } else if (response.status === 403) {
          goTo('/403');
        } else if (response.status === 404) {
          goTo('/404');
        }
      }

      let msg = null;
      if (response.status === 422) {
        response.data = response.data || {};
        msg = TOO_MANY_SEARCH_RESULTS;
      } else if (
        response &&
        response.data &&
        typeof response.data.error === 'string'
      ) {
        msg = response.data.error;
      }

      if (msg) {
        addAlert(msg);
      }

      return Promise.reject(error);
    },
  );
};

export default setupInterceptors;
